import { DocumentService, GoogleDriveAdapter } from '@xq/infrastructure';

export class MoveDriveFileUseCase {
  static async execute(fileId: string, destinationId: string) {
    return DocumentService.getInstance(
      GoogleDriveAdapter.getInstance()
    ).moveDocumentFromStorage(fileId, destinationId);
  }
}
